// extracted by mini-css-extract-plugin
export default {"builder-component-wrapper":"jvLPVo","builderComponentWrapper":"jvLPVo"};